<template>
  <div class="hll-doc" v-html="data"></div>
</template>

<script>
  export default {
    name: 'hllDoc',
    props: ['data'],
  }
</script>

<style lang="scss">
  .hll-doc{
    width: 100%;
    word-break: break-all;
    p, h1, h2, h4, h4, h5, table, pre{
      margin: 10px 0;
      line-height: 1.5;
    }
    pre {
      white-space: pre-wrap;
      max-width: 100%;
      code {
        width: 100%;
        overflow-x: auto;
      }
    }
    img {
      max-width: 100%;
    }
    /* table 样式 */
    table {
      border-top: 1px solid #ccc;
      border-left: 1px solid #ccc;
    }
    table td,
    table th {
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
      padding: 3px 5px;
    }
    table th {
      border-bottom: 2px solid #ccc;
      text-align: center;
    }

    /* blockquote 样式 */
    blockquote {
      display: block;
      border-left: 8px solid #d0e5f2;
      padding: 5px 10px;
      margin: 10px 0;
      line-height: 1.4;
      font-size: 100%;
      background-color: #f1f1f1;
    }

    /* code 样式 */
    code {
      display: inline-block;
      *display: inline;
      *zoom: 1;
      background-color: #f1f1f1;
      border-radius: 3px;
      padding: 3px 5px;
      margin: 0 3px;
    }
    pre code {
      display: block;
    }

    /* ul ol 样式 */
    ul, ol {
      margin: 10px 0 10px 20px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/common/hll-doc.vue